<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Категория об интересном</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <button type="button" @click="sortPosition" class="btn btn-white btn-icon-text my-2 mr-2">
            <i class="ti-exchange-vertical mr-1"></i> Сортировать
          </button>
          <router-link to="/interesting-category/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Добавить категорию
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Спиоск категорий</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="interestingCategoriesList" :fields="tableFields">
                <template #cell(sort)="row">
                  <input type="number" min="0" class="w-25" v-model="row.item.sort">
                </template>
                <template #cell(language)="row">
                  {{row.item.language && row.item.language.name[$i18n.locale] }}
                </template>
                <template #cell(actions)="row">
                  <router-link :to="`/interesting-category/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="row.item.status === 'active'" @click="removeInterestingCategory(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="ti-close"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="restInterestingCategory(row.item.id)" type="button" class="btn btn-outline-success mr-2 mt-1 mb-1">
                      <i class="fe fe-rotate-ccw"></i>
                    </button>
                    <button @click="removeInterestingCategory(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'InterestingCategory',
  data () {
    return {
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {}
    }
  },
  computed: {
    ...mapState({
      interestingCategoriesList: state => state.interesting.interestingCategoriesList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'sort',
          label: 'Очередность',
          sortable: true
        },
        {
          key: 'title.' + this.$i18n.locale,
          label: 'Название категории',
          sortable: true
        },
        {
          key: 'language',
          label: 'Язык обучения',
          sortable: true
        },
        {
          key: 'Действие',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getInterestingCategories({})
  },
  methods: {
    ...mapActions({
      getAllInterestingCategories: 'interesting/getAllInterestingCategories',
      deleteInterestingCategory: 'interesting/deleteInterestingCategory',
      restoreInterestingCategory: 'interesting/restoreInterestingCategory',
      sortPositionInterestingCategory: 'interesting/sortPositionInterestingCategory'
    }),
    getInterestingCategories (params) {
      this.getAllInterestingCategories(params).then(res => {
        this.pagination = res.pagination
      }).catch(() => {
        this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
      })
    },
    changePaginationPerPage (value) {
      this.getAllInterestingCategories({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getAllInterestingCategories({ page: page, count: this.paginationPerPage })
    },
    removeInterestingCategory (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteInterestingCategory(id).then(res => {
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    },
    restInterestingCategory (id) {
      this.restoreInterestingCategory(id).then(res => {
      })
    },
    sortPosition () {
      const formData = { data: [] }
      for (let i = 0; i < this.interestingCategoriesList.length; i++) {
        formData.data.push({ id: this.interestingCategoriesList[i].id, sort: this.interestingCategoriesList[i].sort })
      }
      this.sortPositionInterestingCategory({ data: formData }).then(res => {
        this.getAllInterestingCategories({ page: this.paginationCurrentPage, count: this.paginationPerPage })
        this.$toasted.success(res.data.data).goAway(1500)
      })
    }
  }
}
</script>
